(()=>{
 const form=document.querySelector('#contact-form'),button=document.querySelector('#contact-send'),status=document.querySelector('#contact-status');
 if(!form||!button||!status)return;
 const sent=status.dataset.sent==='true';
 if(sent){button.textContent='Gesendet ✓';button.disabled=true;form.dataset.sent='true';}
 form.addEventListener('input',()=>{if(form.dataset.sent==='true'){delete form.dataset.sent;status.dataset.sent='false';status.textContent='';button.disabled=false;button.textContent='Senden';}});
 form.addEventListener('submit',()=>{button.textContent='Wird gesendet …';button.disabled=true;});
 // A restored page must not retain an unconfirmed, disabled sending state.
 addEventListener('pageshow',event=>{if(event.persisted&&form.dataset.sent!=='true'){button.textContent='Senden';button.disabled=false;}});
})();
